
import { computed, defineComponent, PropType } from 'vue'

interface CargoStatuses {
    [key: number]: string
}

const CARGO_STATUSES: CargoStatuses = {
    22: 'CargoStatus--yellow',
    24: 'CargoStatus--yellow',
    26: 'CargoStatus--yellow',
    27: 'CargoStatus--yellow',
    28: 'CargoStatus--yellow',
    //
    21: 'CargoStatus--blue',
    23: 'CargoStatus--green',
    25: 'CargoStatus--red',
}

export default defineComponent({
    props: {
        status: {
            type: Object as PropType<{ title: string; id: number }>,
            required: true,
        },
    },
    setup(props) {
        const cargoStatusClasses = computed(() => CARGO_STATUSES[props.status.id])

        const iconClass = computed(() => {
            if (props.status.id === 1) return 'fas fa-times-circle'
            return 'fas fa-check-circle'
        })

        return {
            cargoStatusClasses,
            iconClass,
        }
    },
})
